import toast from "react-hot-toast";

export const handleApiError = (error) => {
  if (error?.response?.status === 403) {
    const authorizationErrorMessage =
      "You do not have permission to perform this action.";
    toast.error(authorizationErrorMessage, { id: "authorization-error" });
    return authorizationErrorMessage;
  }

  if (error?.response?.data?.message) {
    const errorMessage = `${error.response.data.message}`;
    toast.error(errorMessage);
    return errorMessage;
  }

  const genericErrorMessage = `Error: ${error.message}`;
  toast.error(genericErrorMessage);
  return error.message;
};
